import { useNavigate, useLocation } from "react-router-dom";

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { label: "Home", icon: "🏠", path: "/" },
    { label: "Categories", icon: "🧰", path: "/materials" },
    { label: "Bookings", icon: "📆", path: "/my-bookings" },
    { label: "Cart", icon: "🛒", path: "/cart" },
    { label: "Account", icon: "👤", path: "/settings" },
  ];

  return (
    <div style={wrapper}>
      {items.map((item) => {
        const active = location.pathname === item.path;

        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            style={{
              ...navBtn,
              color: active ? "#fff" : "#9f9f9f",
              background: active ? "#171717" : "transparent",
            }}
          >
            <div style={{ fontSize: "18px" }}>{item.icon}</div>
            <div style={{ fontSize: "12px", marginTop: "4px" }}>
              {item.label}
            </div>
          </button>
        );
      })}
    </div>
  );
}

const wrapper = {
  position: "fixed",
  left: "50%",
  transform: "translateX(-50%)",
  bottom: "12px",
  width: "min(680px, calc(100% - 16px))",
  background: "rgba(10,10,10,0.95)",
  border: "1px solid #262626",
  borderRadius: "18px",
  padding: "8px",
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: "6px",
  zIndex: 1200,
  backdropFilter: "blur(10px)",
  boxShadow: "0 14px 34px rgba(0,0,0,0.28)",
};

const navBtn = {
  border: "none",
  borderRadius: "14px",
  padding: "10px 8px",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export default BottomNav;